"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var Translation_1 = require("../../../common/components/presentation/Translation/Translation");
var ShowIfTranslationExists_1 = require("../../../common/components/ShowIfTranslationExists");
var ContinueInDealershipStyles_1 = require("./ContinueInDealershipStyles");
var ContinueInDealershipText = function () {
    var style = ContinueInDealershipStyles_1.default();
    var intl = react_intl_1.useIntl();
    return (<>
      <ShowIfTranslationExists_1.default translationKey="confirmation.content.dealership.salutation">
        <core_1.Typography component="h2" variant="body1" data-test="text:confirmation:salutation" className={style.paragraph}>
          <Translation_1.default id="confirmation.content.dealership.salutation"/>
        </core_1.Typography>
      </ShowIfTranslationExists_1.default>
      <core_1.Typography component="h2" variant="body1" data-test="text:confirmation:paragraph1" className={style.paragraph}>
        <Translation_1.default id="confirmation.content.dealership.dealerContact"/>
      </core_1.Typography>
      <core_1.Typography component="h2" variant="body1" data-test="text:confirmation:paragraph2" className={style.paragraph}>
        <Translation_1.default id="confirmation.content.dealership.contactInfo" values={{
        phoneNumber: (<a data-test="text:continueInDealership:phoneNumber" href={"tel:" + intl.formatMessage({ id: 'label.getInTouch.phoneNumber' })}>
                <Translation_1.default id="label.getInTouch.phoneNumber"/>
              </a>),
    }}/>
      </core_1.Typography>
    </>);
};
exports.default = ContinueInDealershipText;
